/* ==========================================================================
   Akmas collection page, assets/akmas-collection.js
   Vanilla ES2019, no dependencies. Client-side filtering, sorting,
   URL state, promo banner, Read-more + FAQ toggles.
   Config: #ak-collection-config (snippets/akmas-collection-config.liquid).
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-akcoll]');
  var configEl = document.getElementById('ak-collection-config');
  if (!root || !configEl) return;

  var cfg;
  try {
    cfg = JSON.parse(configEl.textContent);
  } catch (error) {
    return;
  }

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var i18n = cfg.i18n || {};

  var grid = root.querySelector('[data-akcoll-grid]');
  var cards = grid ? Array.prototype.slice.call(grid.querySelectorAll('[data-akcoll-card]')) : [];
  var promo = root.querySelector('[data-akcoll-promo]');
  var chipsRow = root.querySelector('[data-akcoll-chips]');
  var sortSelect = root.querySelector('[data-akcoll-sort]');
  var appliedWrap = root.querySelector('[data-akcoll-applied]');
  var appliedChips = root.querySelector('[data-akcoll-applied-chips]');
  var clearBtn = root.querySelector('[data-akcoll-clear]');
  var statusEl = root.querySelector('[data-akcoll-status]');
  var countEl = root.querySelector('[data-akcoll-count]');
  var sheet = root.querySelector('[data-akcoll-sheet]');
  var sheetBackdrop = root.querySelector('[data-akcoll-sheet-backdrop]');
  var sheetOpenBtn = root.querySelector('[data-akcoll-sheet-open]');
  var sheetCloseBtn = root.querySelector('[data-akcoll-sheet-close]');
  var sheetClearBtn = root.querySelector('[data-akcoll-sheet-clear]');
  var sheetApplyBtn = root.querySelector('[data-akcoll-sheet-apply]');
  var filterBadge = root.querySelector('[data-akcoll-filter-badge]');
  var noResultsEl = null;

  var state = { gender: [], family: [], price: '', inStock: false, sort: 'best' };

  /* ------------------------------------------------------------------
     Initial order + data extraction
     ------------------------------------------------------------------ */
  cards.forEach(function (card, index) {
    card._idx = index;
    card._price = parseInt(card.getAttribute('data-price'), 10) || 0;
    card._gender = card.getAttribute('data-gender') || '';
    card._family = card.getAttribute('data-family') || '';
    card._tags = card.getAttribute('data-tags') || '';
    card._rating = parseFloat(card.getAttribute('data-rating')) || 0;
    card._published = parseInt(card.getAttribute('data-published'), 10) || 0;
    card._available = card.getAttribute('data-available') === 'true';
  });

  /* ------------------------------------------------------------------
     Populate family + price groups in the sheet from the grid data
     ------------------------------------------------------------------ */
  (function buildSheetFilters() {
    var familyGroup = root.querySelector('[data-akcoll-group="family"]');
    var priceGroup = root.querySelector('[data-akcoll-group="price"]');
    var seen = {};
    if (familyGroup) {
      cards.forEach(function (card) {
        var fam = card._family;
        if (fam && !seen[fam]) {
          seen[fam] = true;
          var label = document.createElement('label');
          var input = document.createElement('input');
          input.type = 'checkbox';
          input.value = fam;
          label.appendChild(input);
          label.appendChild(document.createTextNode(' ' + fam.charAt(0).toUpperCase() + fam.slice(1)));
          familyGroup.appendChild(label);
        }
      });
    }
    if (priceGroup && cfg.prices) {
      cfg.prices.forEach(function (bucket, index) {
        var label = document.createElement('label');
        var input = document.createElement('input');
        input.type = 'radio';
        input.name = 'akcoll-price';
        input.value = String(index);
        label.appendChild(input);
        label.appendChild(document.createTextNode(' ' + bucket.label));
        priceGroup.appendChild(label);
      });
    }
  })();

  /* ------------------------------------------------------------------
     Filtering / sorting
     ------------------------------------------------------------------ */
  function matchesFilters(card) {
    if (state.gender.length && state.gender.indexOf(card._gender) === -1) return false;
    if (state.family.length) {
      var hit = state.family.some(function (fam) {
        return card._family === fam || card._tags.indexOf(fam) !== -1;
      });
      if (!hit) return false;
    }
    if (state.price !== '') {
      var bucket = cfg.prices[parseInt(state.price, 10)];
      if (bucket) {
        if (bucket.max > 0 && card._price > bucket.max) return false;
        if (bucket.max === 0 && card._price < 150000) return false;
        if (bucket.max === 50000 && card._price >= 50000) return false;
        if (bucket.max === 99900 && (card._price < 50000 || card._price > 99900)) return false;
        if (bucket.max === 149900 && (card._price < 99900 || card._price > 149900)) return false;
      }
    }
    if (state.inStock && !card._available) return false;
    return true;
  }

  function sortCards(list) {
    var sorted = list.slice();
    if (state.sort === 'price-asc') sorted.sort(function (a, b) { return a._price - b._price; });
    else if (state.sort === 'price-desc') sorted.sort(function (a, b) { return b._price - a._price; });
    else if (state.sort === 'newest') sorted.sort(function (a, b) { return b._published - a._published; });
    else if (state.sort === 'rating') sorted.sort(function (a, b) { return b._rating - a._rating || b._idx - a._idx; });
    else sorted.sort(function (a, b) { return a._idx - b._idx; });
    return sorted;
  }

  function filterCount() {
    return state.gender.length + state.family.length + (state.price !== '' ? 1 : 0) + (state.inStock ? 1 : 0);
  }

  function apply(options) {
    var opts = options || {};
    var matched = cards.filter(matchesFilters);
    var ordered = sortCards(matched);

    cards.forEach(function (card) {
      card.hidden = true;
      card.classList.remove('is-filtered-out');
    });

    ordered.forEach(function (card) {
      if (grid) grid.insertBefore(card, promo || null);
      card.hidden = false;
    });

    if (noResultsEl) {
      noResultsEl.remove();
      noResultsEl = null;
    }
    if (!ordered.length) {
      noResultsEl = document.createElement('li');
      noResultsEl.className = 'akcoll__noresults';
      noResultsEl.textContent = i18n.noResults || 'No products match these filters.';
      if (grid) grid.appendChild(noResultsEl);
    }

    /* Promo banner: visible once 5+ cards show */
    if (promo) promo.hidden = ordered.length < 5;

    /* Counters */
    var total = ordered.length;
    if (countEl) countEl.textContent = total + (total === 1 ? ' product' : ' products');
    if (statusEl) {
      statusEl.textContent = (filterCount() > 0
        ? (i18n.results || '{count} results').replace('{count}', String(total))
        : '') || '';
    }

    renderApplied();
    syncSheet();
    if (!opts.skipUrl) writeUrl();
  }

  /* ------------------------------------------------------------------
     Applied chips
     ------------------------------------------------------------------ */
  function chipLabel(group, value) {
    if (group === 'gender') {
      return value === 'women' ? 'For her' : value === 'men' ? 'For him' : value.charAt(0).toUpperCase() + value.slice(1);
    }
    if (group === 'family') return value.charAt(0).toUpperCase() + value.slice(1);
    return value;
  }

  function renderApplied() {
    if (!appliedChips || !appliedWrap) return;
    appliedChips.innerHTML = '';
    var entries = [];
    state.gender.forEach(function (v) { entries.push(['gender', v]); });
    state.family.forEach(function (v) { entries.push(['family', v]); });
    if (state.price !== '') {
      var bucket = cfg.prices[parseInt(state.price, 10)];
      entries.push(['price', bucket ? bucket.label : state.price]);
    }
    if (state.inStock) entries.push(['stock', 'In stock']);

    entries.forEach(function (entry) {
      var button = document.createElement('button');
      button.type = 'button';
      button.textContent = chipLabel(entry[0], entry[1]) + ' ×';
      button.setAttribute('data-akcoll-remove', entry[0]);
      button.setAttribute('data-akcoll-remove-value', entry[1]);
      appliedChips.appendChild(button);
    });

    appliedWrap.hidden = entries.length === 0;
    if (filterBadge) {
      var n = filterCount();
      filterBadge.hidden = n === 0;
      filterBadge.textContent = String(n);
    }
  }

  if (appliedChips) {
    appliedChips.addEventListener('click', function (event) {
      var button = event.target.closest('[data-akcoll-remove]');
      if (!button) return;
      var group = button.getAttribute('data-akcoll-remove');
      var value = button.getAttribute('data-akcoll-remove-value');
      removeFilter(group, value);
    });
  }

  function removeFilter(group, value) {
    if (group === 'gender') state.gender = state.gender.filter(function (v) { return v !== value; });
    else if (group === 'family') state.family = state.family.filter(function (v) { return v !== value; });
    else if (group === 'price') state.price = '';
    else if (group === 'stock') state.inStock = false;
    syncChips();
    apply();
  }

  function clearAll() {
    state.gender = [];
    state.family = [];
    state.price = '';
    state.inStock = false;
    syncChips();
    apply();
  }

  if (clearBtn) clearBtn.addEventListener('click', clearAll);
  if (sheetClearBtn) sheetClearBtn.addEventListener('click', clearAll);

  /* ------------------------------------------------------------------
     Quick chips
     ------------------------------------------------------------------ */
  function syncChips() {
    if (!chipsRow) return;
    chipsRow.querySelectorAll('[data-akcoll-chip]').forEach(function (chip) {
      var value = chip.getAttribute('data-akcoll-chip') || '';
      var pressed = false;
      if (value === '') pressed = filterCount() === 0;
      else if (value === 'men' || value === 'women' || value === 'unisex') pressed = state.gender.indexOf(value) !== -1;
      else pressed = state.family.indexOf(value) !== -1;
      chip.setAttribute('aria-pressed', String(pressed));
    });
  }

  if (chipsRow) {
    chipsRow.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-akcoll-chip]');
      if (!chip) return;
      var value = chip.getAttribute('data-akcoll-chip') || '';
      if (value === '') {
        clearAll();
        return;
      }
      if (value === 'men' || value === 'women' || value === 'unisex') {
        if (state.gender.indexOf(value) !== -1) state.gender = state.gender.filter(function (v) { return v !== value; });
        else state.gender.push(value);
      } else {
        if (state.family.indexOf(value) !== -1) state.family = state.family.filter(function (v) { return v !== value; });
        else state.family.push(value);
      }
      syncChips();
      apply();
    });
  }

  /* ------------------------------------------------------------------
     Sort
     ------------------------------------------------------------------ */
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      state.sort = sortSelect.value;
      apply();
    });
  }

  /* ------------------------------------------------------------------
     Filter bottom sheet
     ------------------------------------------------------------------ */
  var lastSheetFocus = null;

  function openSheet() {
    if (!sheet) return;
    lastSheetFocus = document.activeElement;
    sheet.hidden = false;
    if (sheetBackdrop) sheetBackdrop.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    if (sheetCloseBtn) sheetCloseBtn.focus();
    document.addEventListener('keydown', onSheetKey);
  }

  function closeSheet() {
    if (!sheet) return;
    sheet.hidden = true;
    if (sheetBackdrop) sheetBackdrop.hidden = true;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onSheetKey);
    if (lastSheetFocus && lastSheetFocus.focus) lastSheetFocus.focus();
  }

  function onSheetKey(event) {
    if (event.key === 'Escape') closeSheet();
  }

  function syncSheet() {
    if (!sheet) return;
    sheet.querySelectorAll('[data-akcoll-group="gender"] input').forEach(function (input) {
      input.checked = state.gender.indexOf(input.value) !== -1;
    });
    sheet.querySelectorAll('[data-akcoll-group="family"] input').forEach(function (input) {
      input.checked = state.family.indexOf(input.value) !== -1;
    });
    sheet.querySelectorAll('[data-akcoll-group="stock"] input').forEach(function (input) {
      input.checked = state.inStock;
    });
    var priceChecked = sheet.querySelector('[data-akcoll-group="price"] input[value="' + state.price + '"]');
    sheet.querySelectorAll('[data-akcoll-group="price"] input').forEach(function (input) {
      input.checked = input === priceChecked;
    });
    if (sheetApplyBtn) {
      var n = cards.filter(matchesFilters).length;
      sheetApplyBtn.textContent = (i18n.showResults || 'Show {count} results').replace('{count}', String(n));
    }
  }

  if (sheetOpenBtn) sheetOpenBtn.addEventListener('click', openSheet);
  if (sheetCloseBtn) sheetCloseBtn.addEventListener('click', closeSheet);
  if (sheetBackdrop) sheetBackdrop.addEventListener('click', closeSheet);
  if (sheetApplyBtn) {
    sheetApplyBtn.addEventListener('click', function () {
      closeSheet();
      apply();
    });
  }
  if (sheet) {
    sheet.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.type) return;
      var group = input.closest('[data-akcoll-group]');
      if (!group) return;
      var name = group.getAttribute('data-akcoll-group');
      if (name === 'gender' || name === 'family') {
        var list = state[name];
        if (input.checked) {
          if (list.indexOf(input.value) === -1) list.push(input.value);
        } else {
          state[name] = list.filter(function (v) { return v !== input.value; });
        }
      } else if (name === 'stock') {
        state.inStock = input.checked;
      } else if (name === 'price') {
        state.price = input.value;
      }
      syncSheet();
    });
  }

  /* ------------------------------------------------------------------
     URL state (pushState; base canonical stays server-rendered)
     ------------------------------------------------------------------ */
  function writeUrl() {
    var base = root.getAttribute('data-coll-url') || window.location.pathname;
    var params = new URLSearchParams();
    if (state.gender.length) params.set('gender', state.gender.join(','));
    if (state.family.length) params.set('family', state.family.join(','));
    if (state.price !== '') params.set('price', state.price);
    if (state.inStock) params.set('stock', 'in');
    if (state.sort !== 'best') params.set('sort', state.sort);
    var query = params.toString();
    window.history.replaceState(null, '', query ? base + '?' + query : base);
  }

  function readUrl() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('gender')) state.gender = params.get('gender').split(',').filter(Boolean);
    if (params.get('family')) state.family = params.get('family').split(',').filter(Boolean);
    if (params.get('price')) state.price = params.get('price');
    if (params.get('stock') === 'in') state.inStock = true;
    if (params.get('sort')) {
      state.sort = params.get('sort');
      if (sortSelect) sortSelect.value = state.sort;
    }
  }

  window.addEventListener('popstate', function () {
    state.gender = [];
    state.family = [];
    state.price = '';
    state.inStock = false;
    readUrl();
    syncChips();
    apply({ skipUrl: true });
  });

  /* ------------------------------------------------------------------
     Read-more SEO toggle
     ------------------------------------------------------------------ */
  (function seoToggle() {
    var toggle = root.querySelector('[data-akcoll-seo-toggle]');
    var wrap = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
    if (!toggle || !wrap) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      wrap.classList.toggle('is-open', !open);
      toggle.textContent = open ? 'Read more' : 'Read less';
    });
  })();

  /* ------------------------------------------------------------------
     FAQ accordions (one open at a time)
     ------------------------------------------------------------------ */
  root.querySelectorAll('.akcoll__faq-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var open = trigger.getAttribute('aria-expanded') === 'true';
      root.querySelectorAll('.akcoll__faq-trigger').forEach(function (other) {
        other.setAttribute('aria-expanded', 'false');
        var panel = other.nextElementSibling;
        if (panel) panel.hidden = true;
      });
      if (!open) {
        trigger.setAttribute('aria-expanded', 'true');
        var panel = trigger.nextElementSibling;
        if (panel) panel.hidden = false;
      }
    });
  });

  /* ------------------------------------------------------------------
     Init
     ------------------------------------------------------------------ */
  readUrl();
  syncChips();
  apply({ skipUrl: true });
})();
